export default {
}



// WEBPACK FOOTER //
// ./src/app/professional/loading-page/gadget/resources/computed.js